@if (visible()) {
    <ng-container rtBlock="sc-cookie-banner">
        <div rtElem="panel">
            <p rtElem="text">
                <span i18n="@@cookieBannerMessage">
                    Мы используем файлы cookie для аналитики, чтобы улучшать конструктор. Вы можете принять или отклонить их использование.
                </span>
                <a rtElem="link" href="/privacy" i18n="@@cookieBannerLearnMore">Подробнее</a>
            </p>
            <div rtElem="actions">
                <button
                    rtElem="btn"
                    rtButton
                    appearance="outlined"
                    type="button"
                    qa-dataid="cookie-decline"
                    i18n="@@cookieBannerDecline"
                    (click)="decline()">
                    Отклонить
                </button>
                <button rtElem="btn" rtButton type="button" qa-dataid="cookie-accept" i18n="@@cookieBannerAccept" (click)="accept()">
                    Принять
                </button>
            </div>
        </div>
    </ng-container>
}
